if (!customElements.get('doom-newsletter-popup')) {
  customElements.define('doom-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.storageKey = 'doombound.newsletter.pause.v1';
      this.pendingKey = 'doombound.newsletter.pending.v1';
      this.designMode = Boolean(window.Shopify?.designMode);
      this.preview = this.designMode || (window.Shopify?.theme?.role !== 'main' && new URLSearchParams(location.search).get('db_newsletter_preview') === '1');
      this.read = (storage, key) => { try { return Number(storage.getItem(key)) || 0; } catch { return 0; } };
      this.write = (storage, key, value) => { try { storage.setItem(key, String(value)); } catch {} };
      const pending = this.read(sessionStorage, this.pendingKey);
      const ownSubmission = pending > Date.now() - 300000;
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        if (!this.preview) this.write(localStorage, this.storageKey, Math.max(this.read(localStorage, this.storageKey), Date.now() + Number(this.dataset.days) * 86400000));
        this.lastFocus?.focus?.({ preventScroll: true });
      }, options);
      this.querySelector('form')?.addEventListener('submit', () => this.write(sessionStorage, this.pendingKey, Date.now()), options);
      if (ownSubmission && this.querySelector('[data-form-success], [data-form-error]')) {
        this.write(sessionStorage, this.pendingKey, 0);
        if (this.querySelector('[data-form-success]')) this.write(localStorage, this.storageKey, Date.now() + 365 * 86400000);
        this.open();
        return;
      }
      if (this.querySelector('[data-form-success]')) return;
      if (this.preview) { this.open(); return; }
      if (this.dataset.eligible !== 'true' || this.read(localStorage, this.storageKey) > Date.now() || /\/challenge|\/account|\/cart|\/policies/.test(location.pathname)) return;
      this.ready = false;
      this.started = false;
      this.check = () => {
        if (this.started || !this.ready || this.dialog.open) return;
        const span = document.documentElement.scrollHeight - innerHeight;
        if (span <= 0 || scrollY / span * 100 < Number(this.dataset.scroll)) return;
        const visibleDialog = [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')].some(element => {
          const rect = element.getBoundingClientRect();
          const style = getComputedStyle(element);
          return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
        });
        if (visibleDialog) return;
        const banner = document.getElementById('shopify-pc__banner');
        if (banner && banner.getBoundingClientRect().height > 0) return;
        if (document.activeElement?.matches('input, textarea, select')) return;
        this.started = true;
        this.open();
      };
      window.addEventListener('scroll', this.check, { passive: true, signal: this.abort.signal });
      this.timer = setTimeout(() => { this.ready = true; this.check(); }, Number(this.dataset.delay) * 1000);
      this.observer = new MutationObserver(() => this.check());
      this.observer.observe(document.body, { childList: true, subtree: true });
    }
    open() {
      this.observer?.disconnect();
      if (this.check) window.removeEventListener('scroll', this.check);
      this.lastFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      const heading = this.querySelector('[data-form-success] h2') || this.querySelector('h2');
      if (heading) {
        this.dialog.setAttribute('aria-labelledby', heading.id);
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
    }
  });
}
